import authTokenUtil from '../../account/authTokenUtil';
import getRedirectQueryString from '../../account/getRedirectQueryString';

export default (
  host: string,
  beforeRedirect: () => void,
  redirectPath?: string,
) => {
  const authToken = authTokenUtil.get();

  const url = new URL(
    `https://${host}/login${getRedirectQueryString(redirectPath)}`,
  );

  if (authToken) {
    url.searchParams.set('authToken', authToken);
  }

  beforeRedirect();
  document.location.href = url.toString();
};
